// src/icons/LogoOnCircle.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function LogoOnCircle() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_469_6261)", children: [
          /* @__PURE__ */ jsx("circle", { cx: "15", cy: "15", r: "15", fill: "#FFF14E" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M14.901 15.6596H8.94529L17.3565 8.29803L15.7099 11.8657H16.6535L19.8216 5L6.66797 16.5166H14.5062L14.901 15.6596Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M14.9638 13.4834L14.569 14.3404H20.5247L12.1135 21.702L13.7601 18.1343H12.8165L12.1713 19.5354L9.64844 25L22.802 13.4834H14.9638Z",
              fill: "black"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_469_6261", children: /* @__PURE__ */ jsx("rect", { width: "30", height: "30", fill: "white" }) }) })
      ]
    }
  );
}

export {
  LogoOnCircle
};
